import { useQuery } from '@tanstack/react-query';

import { useAccessToken } from '../auth/AccessTokenContext';
import { getApiV1JobsByIdStatus } from '../api';
import { queryKeys } from './queryKeys';

export const useFetchJobStatus = (id: string | undefined) => {
  const token = useAccessToken();
  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: queryKeys.jobs(id as string),
    queryFn: () =>
      getApiV1JobsByIdStatus({
        path: { id: id as string },
      }),
    enabled: !!token && id !== undefined,
    refetchInterval: 30000,
  });

  return query;
};
